/* ----------------------------------------------------------
VALIDAÇÃO DE FORMULÁRIOS
-------------------------------------------------------------*/

var FormValidation = function()
{
    function validateEmail($email)
    {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test( $email );
    }

    function validateCPF(cpf_field)
    {
        var cpf = cpf_field.replace(/[^0-9]/g, '').toString();

        if( cpf.length == 11 )
        {
            var v = [];

            // Calcula o primeiro dígito de verificação.
            v[0] = 1 * cpf[0] + 2 * cpf[1] + 3 * cpf[2];
            v[0] += 4 * cpf[3] + 5 * cpf[4] + 6 * cpf[5];
            v[0] += 7 * cpf[6] + 8 * cpf[7] + 9 * cpf[8];
            v[0] = v[0] % 11;
            v[0] = v[0] % 10;

            // Calcula o segundo dígito de verificação.
            v[1] = 1 * cpf[1] + 2 * cpf[2] + 3 * cpf[3];
            v[1] += 4 * cpf[4] + 5 * cpf[5] + 6 * cpf[6];
            v[1] += 7 * cpf[7] + 8 * cpf[8] + 9 * v[0];
            v[1] = v[1] % 11;
            v[1] = v[1] % 10;

            // Retorna Verdadeiro se os dígitos de verificação são os esperados.
            if ( (v[0] != cpf[9]) || (v[1] != cpf[10]) )
            {
                return false;
            }
            else
            {
                return true;
            }
        }
        else
        {
           return false;
        }
    }

    this.testFields = function(form)
    {
        var range = 0,
            mensagem = '<ul>';
            
        form.find('.requiredField').each(function()
        {
            $(this).removeClass('error');
            $(this).parent().removeClass('error');
            
            var field = $(this),
                title = $(this).attr('title'),
                fieldName = $(this).attr('name');
            
            switch(field.attr('type'))
            {
                case 'text':
                    if(fieldName == 'cpf')
                    {
                        if(validateCPF(field.val()) == false)
                        {
                            $(this).addClass('error');
                            mensagem += '<li>O campo "'+title+'" está inválido</li>';
                            range++;
                        }
                    }
                    else
                    {
                        if(field.val().length <= 0)
                        {
                            $(this).addClass('error');
                            mensagem += '<li>O campo "'+title+'" não pode ser vazio</li>';
                            range++;
                        }
                    }
                break;

                case 'email':
                    if( field.val().length <= 0 || !validateEmail( field.val() ) )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo "'+title+'" está vazio ou incorreto</li>';
                        range++;
                    }
                break;

                case 'textarea':
                    if( field.val().length <= 0 )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo "'+title+'" é obrigatório</li>';
                        range++;
                    }
                break;

                case 'password':
                    if( field.val().length <= 0 )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo de "'+title+'" está incorreto</li>';
                        range++;
                    }
                break;

                case 'search':
                    if( field.val().length <= 0 )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo de "'+title+'" não pode ser vazio</li>';
                        range++;
                    }
                break;

                case 'select':
                    if( parseInt(field.val()) <= 0 )
                    {
                        $(this).parent().addClass('error');
                        mensagem += '<li>O campo de "'+title+'" é obrigatório</li>';
                        range++;
                    }
                break;
                
                case 'checkbox':
                    
                    var total = 0;
                    
                    field.find('input[type="checkbox"]').each(function()
                    {
                        if( $(this).is(':checked') )
                        {
                            total++;
                        }
                    });
                    
                    if( total <= 0 )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo de '+title+' é obrigatório</li>';
                        range++;
                    }

                break;

                case 'radio':
                    
                    var total = 0;
                    
                    field.find('input[type="radio"]').each(function()
                    {
                        if( $(this).is(':checked') )
                        {
                            total++;
                        }
                    });
                    
                    if( total <= 0 )
                    {
                        $(this).addClass('error');
                        mensagem += '<li>O campo de '+title+' é obrigatório</li>';
                        range++;
                    }
                    
                break;
            }
        });

        mensagem += '</ul>';
        
        if(range > 0)
        {
            return {
                status      : false,
                mensagem : '<div class="alertBox formError"><h1>Erro no Formulário.</h1><ul class="listError" role="list" aria-label="Lista de erros de preenchimento">'+mensagem+'</ul><a href="#" class="closeAlert" title="Fechar Mensagem"><i class="icon-cancel"></i></a></div>'
            };
        }
        else
        {
            return {
                status      : true,
                mensagem : ''
            };
        }
    }

    this.manualMessages = function(form,type,msg)
    {
        form.find('.alertsMessages').html('<div class="alertBox '+type+'">'+msg+'<a href="#" class="closeAlert" title="Fechar Mensagem"><i class="icon-cancel"></i></a></div>');
    }

    this.alertMessages = function(form)
    {
        var alertsMessages   = form.find('.alertsMessages'),
            closeAlert       = alertsMessages.find('a.closeAlert'),
            altura          = alertsMessages.find('.alertBox').innerHeight();

        alertsMessages.stop().animate({height : altura + 30, opacity : 1},300,function()
        {
            $('html,body').stop().animate({ scrollTop : alertsMessages.offset().top - 110},1000);
        });

        alertsMessages.find('.listError').focus();

        closeAlert.on('click',function(e)
        {
            e.preventDefault();

            alertsMessages.stop().animate({height : 0, opacity : 0},300);
        });
    }
}

/* ----------------------------------------------------------
FORMULÁRIOS
-------------------------------------------------------------*/

function myCallBack()
{
    if($('#formComercializacaoLojista').length > 0)
    {
        _fnEnviaFormuláriosFinal
        (
            {
                method      : 'post',
                formulario  : 'formComercializacaoLojista'
            }
        );
    }
    
    if($('#formComercializacaoAnunciar').length > 0)
    {
        _fnEnviaFormuláriosFinal
        (
            {
                method      : 'post',
                formulario  : 'formComercializacaoAnunciar'
            }
        );
    }

    if($('#formComercializacaoEspaco').length > 0)
    {
        _fnEnviaFormuláriosFinal
        (
            {
                method      : 'post',
                formulario  : 'formComercializacaoEspaco'
            }
        );
    }
    
    if($('#formClubeEmpresa').length > 0)
    {
        cadastroClubeEmpresa();
    }

    if($('#formContato').length > 0)
    {
        _fnEnviaFormuláriosFinal
        (
            {
                method      : 'post',
                formulario  : 'formContato'
            }
        );
    }

    if($('#formProtecaoDados').length > 0)
    {
        ProtecaoDadosSubmitForm
        (
            {
                method      : 'post',
                formulario  : 'formProtecaoDados'
            }
        );
    }

    if($('#formNewsletter').length > 0)
    {
        enviaFormulários
        (
            {
                method      : 'post',
                formulario  : 'formNewsletter'
            }
        );
    }
    
    if($('#formTrabalheConosco').length > 0)
    {
        TrabalheConoscoForm
        (
            {
                method      : 'post',
                formulario  : 'formTrabalheConosco'
            }
        );
    }
}

var _fnEnviaFormuláriosFinal = function(settings)
{
    var validacao = new FormValidation();
     
    var $form = $('#'+settings.formulario);

    $form.find('.captcha').find('.submit').html('<button form="'+settings.formulario+'" type="submit" class="btn big full verde">Enviar</button><input type="reset" value="Resetar formulário" hidden="hidden">');
    $form.attr('action', $form.data('action') );

    $form.on('submit',function(e)
    {
        e.preventDefault();

        var retornoValidacao = validacao.testFields($form);

        $form.find('.captcha .submit button.btn.verde').addClass('sending');

        
        /* VALIDA OS CAMPOS OBRIGATÓRIOS */
            
        if( retornoValidacao.status == true )
        {    
            /* ----------------------------------- AQUI VAI O AJAX ----------------------------------- */

            var sendFormAction = jQuery.ajax(
            {
                type: "post",
                url: $form.data('action'),
                data: $form.serialize(),
            });

            sendFormAction.done(function(result,statusText,xhr)
            {
                console.log(xhr.status)
                if(xhr.status == 200)
                {
                    var msg = '<h1>Solicitação efetuada com sucesso!</h1>';
                        msg += (JSON.parse(xhr.responseText) && JSON.parse(xhr.responseText) != "") ? '<p>'+JSON.parse(xhr.responseText)+'</p>' : '';

                    validacao.manualMessages($form,'formSucesso',msg);
                }
                else
                {
                    var msg = '<h1>Houve um erro em sua solicitação!</h1>';
                    if(xhr.statusText)
                    {
                        msg += '<p>'+xhr.statusText+'</p>';
                    }

                    validacao.manualMessages($form,'formError',msg);
                    
                }
                
                validacao.alertMessages($form);
            
                $form.find('input[type="reset"]').trigger('click');
                $form.find('.captcha .submit button.btn.verde').removeClass('sending');
            });	
            
            sendFormAction.fail(function(error)
            {
                var $msgs = '<h1>Houve um erro em sua solicitação!</h1>';
                
                try {
                    var arrayError = JSON.parse(error.responseText);
                    if(arrayError && arrayError.length > 0)
                    {
                        $msgs += '<ul>';
                        for(var i = 0; i < arrayError.length; i++)
                        {
                            $msgs += '<li>'+arrayError[i]+'</li>';
                        }
                        $msgs += '</ul>';
                    } else {
                        $msgs += '<p>'+error.responseText+'</p>';
                    }
                } catch (e) {
                    $msgs += '<p>Erro desconhecido</p>';
                }
                
                validacao.manualMessages($form,'formError',$msgs);
                validacao.alertMessages($form);

                $form.find('.captcha .submit button.btn.verde').removeClass('sending');
            });
        }
        else
        {
            e.preventDefault();

            $form.find('.alertsMessages').html(retornoValidacao.mensagem);

            validacao.alertMessages($form);

            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
        }
    });
}

var enviaFormulários = function(settings)
{
    var validacao = new FormValidation();
     
    var $form = $('#'+settings.formulario);

    $form.find('.captcha').find('.submit').html('<button form="'+settings.formulario+'" type="submit" class="btn big full verde">Enviar</button><input type="reset" value="Resetar formulário" hidden="hidden">');
    $form.attr('action', $form.data('action') );

    if(settings.formulario != 'formNewsletter')
    {
        $form.on('submit',function(e)
        {
            $form.find('.captcha .submit button.btn.verde').addClass('sending');
            
            var retornoValidacao = validacao.testFields($form);
            
            /* VALIDA OS CAMPOS OBRIGATÓRIOS */
            
            if( retornoValidacao.status == true )
            {
                return true;
            }
            else
            {
                e.preventDefault();
                
                $form.find('.alertsMessages').html(retornoValidacao.mensagem);
                validacao.alertMessages($form);

                $form.find('.captcha .submit button.btn.verde').removeClass('sending');
            }
        });
    }
    else
    {
        /* ----------------------------------------------------------
            
        FORMULÁRIO DE NEWSLETTER
            
        ------------------------------------------------------------ */

        $form.on('submit',function(e)
        {
            e.preventDefault();

            var retornoValidacao = validacao.testFields($form);

            $form.find('.captcha .submit button.btn.verde').addClass('sending');

            
            /* VALIDA OS CAMPOS OBRIGATÓRIOS */
                
            if( retornoValidacao.status == true )
            {    
                /* ----------------------------------- AQUI VAI O AJAX ----------------------------------- */

                var registerNewsletter = $.ajax({
                            type: "post",
                            url: $form.data('action'),
                            data: $form.serialize(),
                            dataType: "json"
                        });

                        registerNewsletter.done(function(result,statusText,xhr)
                        {
                            if(result.OcorreuErro)
                            {
                                var msg = '<h1>Ocorreu um erro ao enviar seu cadastro:</h1>';
                                    msg += '<p>'+result.mensagem+'</p>';

                                validacao.manualMessages($form,'formError',msg);
                            }
                            else
                            {
                                var msg = '<h1>Cadastro realizado com sucesso!</h1>';
                                    msg += '<p>'+result.mensagem+'</p>';
                                    msg += (result.tag && result.tag != "") ? '<p>'+result.tag+'</p>' : '';

                                validacao.manualMessages($form,'formSucesso',msg);
                                
                                $form.find('input[type="reset"]').trigger('click');
                            }
                            
                            validacao.alertMessages($form);

                            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                        });	
                        
                        registerNewsletter.fail(function(error)
                        {
                            var $msgs = '<p><strong>Ocorreu um erro ao enviar seu cadastro. Por favor, tente novamente mais tarde.</strong></p>';
                                
                            try {
                                $msgs += '<p>'+jQuery.parseJSON(error.responseText)[0].message+'</p>';
                            } catch (e) {
                                $msgs += '<p>Erro desconhecido</p>';
                            }
                            
                            validacao.manualMessages($form,'formError',$msgs);
                            validacao.alertMessages($form);

                            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                        });
            }
            else
            {
                e.preventDefault();

                $form.find('.alertsMessages').html(retornoValidacao.mensagem);

                validacao.alertMessages($form);

                $form.find('.captcha .submit button.btn.verde').removeClass('sending');
            }
        });
    }
}

var ProtecaoDadosSubmitForm = function(settings)
{
    var validacao = new FormValidation();
     
    var $form = $('#'+settings.formulario);

    $form.find('.captcha').find('.submit').html('<button form="'+settings.formulario+'" type="submit" class="btn big full verde">Enviar</button><input type="reset" value="Resetar formulário" hidden="hidden">');
    $form.attr('action', $form.data('action') );
    

    $form.on('submit',function(e)
    {
        e.preventDefault();

        var retornoValidacao = validacao.testFields($form);

        $form.find('.captcha .submit button.btn.verde').addClass('sending');

        
        /* VALIDA OS CAMPOS OBRIGATÓRIOS */
            
        if( retornoValidacao.status == true )
        {    
            /* ----------------------------------- AQUI VAI O AJAX ----------------------------------- */

            var cleanDadosProtecao = jQuery.ajax({
                        type: "post",
                        url: $form.data('action'),
                        data: $form.serialize(),
                    });

                    cleanDadosProtecao.done(function(result,statusText,xhr)
                    {
                        if(xhr.status == 200)
                        {
                            var msg = '<h1>Solicitação efetuada com sucesso!</h1>';
                                msg += (JSON.parse(xhr.responseText) && JSON.parse(xhr.responseText) != "") ? '<p>'+JSON.parse(xhr.responseText)+'</p>' : '';

                            validacao.manualMessages($form,'formSucesso',msg);
                        }
                        else
                        {
                            var msg = '<h1>Houve um erro em sua solicitação!</h1>';
                                msg += '<p>'+xhr.statusText+'</p>';

                            validacao.manualMessages($form,'formError',msg);
                            
                        }
                         
                        validacao.alertMessages($form);
                    
                        $form.find('input[type="reset"]').trigger('click');
                        $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                    });	
                    
                    cleanDadosProtecao.fail(function(error)
                    {
                        var $msgs = '<h1>Houve um erro em sua solicitação!</h1>';
                        
                        try {
                            var arrayError = JSON.parse(error.responseText);
                            if(arrayError && arrayError.length > 0)
                            {
                                $msgs += '<ul>';
                                for(var i = 0; i < arrayError.length; i++)
                                {
                                    $msgs += '<li>'+arrayError[i]+'</li>';
                                }
                                $msgs += '</ul>';
                            } else {
                                $msgs += '<p>'+error.responseText+'</p>';
                            }
                        } catch (e) {
                            $msgs += '<p>Erro desconhecido</p>';
                        }
                        
                        validacao.manualMessages($form,'formError',$msgs);
                        validacao.alertMessages($form);

                        $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                    });
        }
        else
        {
            e.preventDefault();
            
            $form.find('.alertsMessages').html(retornoValidacao.mensagem);

            validacao.alertMessages($form);

            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
        }
    });
}

var cadastroClubeEmpresa = function()
{
    var validacao = new FormValidation();
    var $form = $('#formClubeEmpresa');
    var $alertsMessages = $form.find('.alertsMessages');

    $form.find('.captcha').find('.submit').html('<button form="formClubeEmpresa" type="submit" class="btn big full verde">Enviar</button><input type="reset" value="Resetar formulário" hidden="hidden">');
    $form.attr('action', $form.data('action') );

    $form.find('input[type="file"]').on('change',function()
    {
        $form.find('span.filename').text( $(this).val() );
    });

    $form.on('submit',function(e)
    {
        e.preventDefault();

        var retornoValidacao = validacao.testFields($form);

        var $this = $form;

        $form.find('.captcha .submit button.btn.verde').addClass('sending');
        
        /* VALIDA OS CAMPOS OBRIGATÓRIOS */
        
        if( retornoValidacao.status == true)
        {
            $.ajax(
            {
                    type        : 'POST',
                    url         : $this.data('action'),
                    data        : new FormData($this[0]),
                    cache       : false,
                    contentType : false,
                    processData : false,
                    success     : function (data)
                    {
                        $this.find('input[type="reset"]').trigger('click');
                         
                        var msg = '<h1>Dados enviados com sucesso!</h1>';
                            msg += '<p>Em breve um de nossos representantes entrará em contato para dar continuidade ao processo de cadastro.</p>';
                            msg += (jQuery.parseJSON(data) && jQuery.parseJSON(data) != "") ? '<p>'+jQuery.parseJSON(data)+'</p>' : '';

                        validacao.manualMessages($form,'formSucesso',msg);
                        validacao.alertMessages($form);

                        $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                    },
                    error       : function(data)
                    {
                        var errorMsg = '<h1>Erro ao enviar dados</h1>';
                        try {
                            var $msgs = jQuery.parseJSON(data.responseText);
                            $.each($msgs.error, function (index, value)
                            {
                                $('input[name="' + index + '"').addClass('error');
                                errorMsg += '<p>' + value + '</p>';
                            });
                        } catch (e) {
                            errorMsg += '<p>Erro desconhecido</p>';
                        }

                        validacao.manualMessages($form,'formError',errorMsg);
                        validacao.alertMessages($form);

                        $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                    }
                });
        }
        else
        {    
            $form.find('.alertsMessages').html(retornoValidacao.mensagem);

            validacao.alertMessages($form);

            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
        }
    });
}

var TrabalheConoscoForm = function(settings) {
    
    /* ----------------------------------------------------------
            
        FORMULÁRIO DE TRABALHE CONOSCO
        
    ------------------------------------------------------------ */

    var validacao = new FormValidation();
     
    var $form = $('#'+settings.formulario);

    $form.find('.captcha').find('.submit').html('<button form="'+settings.formulario+'" type="submit" class="btn big full verde">Enviar</button><input type="reset" value="Resetar formulário" hidden="hidden">');
    $form.attr('action', $form.data('action') );
    

    /* ----------------------------------------------------------
            
        FORMULÁRIO CURRÍCULO
        
    ------------------------------------------------------------ */
    
    if(settings.formulario == 'formTrabalheConosco') {
        $form.on('submit',function(e)
        {
            e.preventDefault();
    
            var retornoValidacao = validacao.testFields($form);
            
            var $this = $form;
            
            $form.find('.captcha .submit button.btn.verde').addClass('sending');
    
            /* VALIDA OS CAMPOS OBRIGATÓRIOS */
            
            if( retornoValidacao.status == true)
            {
                $.ajax(
                {
                        type        : 'POST',
                        url         : $this.data('action'),
                        data        : new FormData($this[0]),
                        cache       : false,
                        contentType : false,
                        processData : false,
                        success     : function (data)
                        {
                            $this.find('input[type="reset"]').trigger('click');
                             
                            var msg = '<h1>Dados enviados com sucesso!</h1>';
                                msg += '<p>Obrigado. Seus dados foram cadastrados com sucesso em nossa base.</p>';
                                msg += (jQuery.parseJSON(data) && jQuery.parseJSON(data) != "") ? '<p>'+jQuery.parseJSON(data)+'</p>' : '';
    
                            validacao.manualMessages($form,'formSucesso',msg);
                            validacao.alertMessages($form);
    
                            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                        },
                        error       : function(data)
                        {
                            var errorMsg = '<h1>Erro ao enviar dados</h1>';
                            try {
                                var $msgs = jQuery.parseJSON(data.responseText);
                                $.each($msgs, function (index, value)
                                {
                                    console.log(value);
                                    errorMsg += '<p>' + value + '</p>';
                                });
                            } catch (e) {
                                errorMsg += '<p>Erro desconhecido</p>';
                            }
    
                            validacao.manualMessages($form,'formError',errorMsg);
                            validacao.alertMessages($form);
    
                            $form.find('.captcha .submit button.btn.verde').removeClass('sending');
                        }
                    });
            }
            else
            {
                $form.find('.alertsMessages').html(retornoValidacao.mensagem);
                
                validacao.alertMessages($form);
    
                $form.find('.captcha .submit button.btn.verde').removeClass('sending');
            }
        });
    }
}

/* ----------------------------------------------------------
    ENVIO WEBFORM
-------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('form[data-webform]');
    const siteKey = window.recaptchaSiteKey;

    forms.forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const dadosUsuario = {};
            
            const inputs = form.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
                dadosUsuario[input.name] = input.value;
            });
            dadosUsuario['webform_id'] = form.getAttribute('data-webform');
            
            // executa reCAPTCHA - inicio
            grecaptcha.ready(() => {
                grecaptcha.execute(siteKey, { action: 'submit' }).then(token => {
                    // adiciona o token no payload
                    dadosUsuario['recaptcha_token'] = token;

                    fetch('/webform_rest/submit', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify(dadosUsuario)
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log('Dados enviados com sucesso:', data);

                        const messageContent = `
                            <h3>Dados enviados com sucesso!</h3>
                            <h5>Obrigado. Seus dados foram cadastrados em nossa base.</h5>
                            ${data.message ? `<p>${data.message}</p>` : ''}
                        `;
                        showMessage('success', messageContent, form);

                        // Limpa os campos do formulário
                        inputs.forEach(input => input.value = '');
                    })
                    .catch((error) => {
                        console.error('Erro ao enviar dados:', error);

                        const messageContent = `
                            <h3>Erro ao enviar formulário!</h3>
                            <h5>${error.message || 'Por favor, tente novamente mais tarde.'}</h5>
                        `;
                        showMessage('error', messageContent, form);
                    });
                // executa reCAPTCHA fim
                });
            });
        });
    });


});

function showMessage(type, content, form) {
    const toast = document.createElement('div');
    toast.classList.add('toast-message', type);
    toast.innerHTML = content;
    
    if (form) {
        form.parentNode.insertBefore(toast, form.nextSibling);
    } else {
        document.body.appendChild(toast);
    }
    
    setTimeout(() => {
        toast.remove();
    }, 5000);
}


/* ----------------------------------------------------------
	ENVIO WEBFORM Mensagem
-------------------------------------------------------------*/

function showMessage(type, content) {
   
    const toast = document.createElement('div');
    toast.classList.add('toast-message', type);  
    toast.innerHTML = content;

    // Adiciona o toast ao body
    document.body.appendChild(toast);

    
    setTimeout(() => {
        toast.style.opacity = '1';  
    }, 100);  

   
    setTimeout(() => {
        toast.style.opacity = '0';  
        
        setTimeout(() => {
            toast.remove();
        }, 2000);  
    }, 6000);
}


/* ----------------------------------------------------------
	ENVIO WEBFORM valida newsletter
-------------------------------------------------------------*/
function validarFormularioNewsletter(form) {
    const emailField = form.querySelector('input[name="e_mail"]');
    const whatsappField = form.querySelector('input[name="telefone"]');

    
    if (!emailField.value && !whatsappField.value) {
        const messageContent = `
            <h3>Erro ao enviar o formulário!</h3>
            <h5>Por favor, preencha pelo menos o campo de e-mail ou WhatsApp.</h5>
        `;
        showMessage('error', messageContent, form);
        return false; 
    }

    return true; 
}


/* ----------------------------------------------------------
	RECAPTCHA valida 
-------------------------------------------------------------*/

// function grecaptchaExecute(form) {
//     return new Promise((resolve, reject) => {
// 		const action = form.getAttribute('data-webform');
// 		const dataKeyElement = document.querySelector('.recaptcha-key');
//         const siteKey = dataKeyElement.getAttribute('data-key');
		
//         grecaptcha.ready(function() {
//             grecaptcha.execute(siteKey, {action: action}).then(function(token) {
//                 // Criar um input hidden no formulário para enviar o token
//                 let recaptchaInput = document.createElement('input');
//                 recaptchaInput.setAttribute('type', 'hidden');
//                 recaptchaInput.setAttribute('name', 'recaptcha_token');
//                 recaptchaInput.setAttribute('value', token);
//                 form.appendChild(recaptchaInput);

//                 resolve(token);
//             }).catch(function(error) {
//                 reject(error);
//             });
//         });
//     });
// }